import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { numberWithCurrencyFormat, stringIsNullOrEmpty } from "../../util/Util";
import { WebUrl } from "../../util/Constant";

const phaseKey = {
    future: "GIVEAWAY_FUTURE",
    ongoing: "GIVEAWAY_ONGOING",
    complete: "GIVEAWAY_COMPLETE"
};
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function formatGiveawayDate(value) {
    if (stringIsNullOrEmpty(value)) {
        return "—";
    }
    const parsed = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }
    return String(parsed.getDate()).padStart(2, "0") + " " + months[parsed.getMonth()] + " " + parsed.getFullYear();
}

function formatCount(value) {
    return Number(value || 0).toLocaleString();
}

function earnedLabel(t, count) {
    const total = Number(count) || 0;
    return t(total === 1 ? "GIVEAWAY_EARNED_ONE" : "GIVEAWAY_EARNED", { count: formatCount(total) });
}

const Giveaway = ({ campaign }) => {
    const { t } = useTranslation();
    const _history = useHistory();

    if (!campaign) {
        return null;
    }

    const showBar = campaign.targetTicket != null && Number(campaign.targetTicket) > 0;
    const target = Number(campaign.targetTicket);
    const total = Number(campaign.ticketTotal) || 0;
    const percent = showBar ? Math.round(Math.min(100, (total / target) * 100)) : 0;

    return (
        <article className="gw-card">
            {!stringIsNullOrEmpty(campaign.giveawayImage) ? (
                <img className="gw-banner" src={campaign.giveawayImage} alt={campaign.campaignName} />
            ) : (
                <div className="gw-banner gw-banner-empty">{campaign.campaignName}</div>
            )}
            <div className="gw-card-body">
                <div className="gw-status-row">
                    <div className="gw-tags">
                        <span className={"gw-status is-" + campaign.phase}>
                            <span className="gw-dot" />
                            {t(phaseKey[campaign.phase] || "GIVEAWAY")}
                        </span>
                        <span className="gw-type">{t("GIVEAWAY")}</span>
                    </div>
                </div>
                <h3 className="gw-title">{campaign.campaignName}</h3>
                {campaign.amountPerTicket != null && Number(campaign.amountPerTicket) > 0 && (
                    <div className="gw-per-ticket"><strong>RM {numberWithCurrencyFormat(parseFloat(campaign.amountPerTicket), 2)}</strong><span>{t("GIVEAWAY_PER_TICKET")}</span></div>
                )}
                {showBar && (
                    <div className="gw-meter">
                        <div className="gw-count"><strong>{formatCount(total)}</strong><span>/{formatCount(target)}</span></div>
                        <div
                            className="gw-bar"
                            role="progressbar"
                            aria-valuemin="0"
                            aria-valuemax={target}
                            aria-valuenow={Math.min(total, target)}
                            aria-label={formatCount(total) + "/" + formatCount(target)}
                        >
                            <div className="gw-bar-fill" style={{ width: percent + "%" }} />
                        </div>
                        <div className="gw-note">{percent}% {t("GIVEAWAY_ISSUED_NOTE")}</div>
                    </div>
                )}
                {campaign.phase === "ongoing" && campaign.myTicket != null && (
                    <div className="gw-earned">{earnedLabel(t, campaign.myTicket)}</div>
                )}
                <div className="gw-dates">
                    <div>
                        <div className="gw-date-label">{t("START_DATE")}</div>
                        <div className="gw-date-value">{formatGiveawayDate(campaign.startDate)}</div>
                    </div>
                    <div>
                        <div className="gw-date-label">{t("END_DATE")}</div>
                        <div className="gw-date-value">{formatGiveawayDate(campaign.endDate)}</div>
                    </div>
                </div>
                <div className="gw-actions">
                    <button
                        type="button"
                        className="gw-view"
                        onClick={() => _history.push({ pathname: WebUrl._URL_GIVEAWAY_DETAIL, state: { id: campaign.id } })}
                    >
                        {t("GIVEAWAY_VIEW")}
                    </button>
                    {campaign.phase === "ongoing" && (
                        <button
                            type="button"
                            className="gw-join"
                            onClick={() => _history.push(WebUrl._URL_DEPOSIT)}
                        >
                            {t("GIVEAWAY_JOIN")}
                        </button>
                    )}
                </div>
            </div>
        </article>
    );
};

export default Giveaway;
